import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {PreparationModifierSearchModel} from "../../preparation-modifier/preparation-modifier-search-model.service";
import {MetaTagDefinitionData, MetaTagType} from "../meta-tag.data";
import {
    PreparationModifierEditPageComponent
} from "../../preparation-modifier/preparation-modifier-edit-page/preparation-modifier-edit-page.component";
import {
    PreparationModifierSearchPageComponent
} from "../../preparation-modifier/preparation-modifier-search-page/preparation-modifier-search-page.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {
    DocketSelectorSearchPageComponent
} from "../../../order-processing/docket-selector/docket-selector-search-page/docket-selector-search-page.component";
import {
    DocketSelectorEditPageComponent
} from "../../../order-processing/docket-selector/docket-selector-edit-page/docket-selector-edit-page.component";
import {
    OrderReadyQualifierSearchPageComponent
} from "../../../order-processing/order-ready-qualifier/order-ready-qualifier-search-page/order-ready-qualifier-search-page.component";
import {
    OrderReadyQualifierEditPageComponent
} from "../../../order-processing/order-ready-qualifier/order-ready-qualifier-edit-page/order-ready-qualifier-edit-page.component";

@Component({
    selector: "wbo-meta-tag-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MetaTagMultiSelectEditControlComponent),
        provideSearchModel(PreparationModifierSearchModel)
    ]
})
export class MetaTagMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<PreparationModifierSearchModel> {
    @Input() includeMatchNoTags: boolean = false;
    @Input() matchNoTagsLabel: string = "wbo.meta-tag.option.modifier.matchNoTags";

    private _type: MetaTagType;

    constructor(model: PreparationModifierSearchModel, injector: Injector) {
        super(model, injector, "metaTagDefinitionId", "name", true);
    }

    get type(): MetaTagType {
        return this._type;
    }

    @Input()
    set type(type: MetaTagType) {
        this._type = type;
        this.model.filter["type"] = type;

        this.extendedSearchComponent = undefined;
        this.extendedEditComponent = undefined;
        this.extendedSearchComponentParams = {};
        this.extendedEditComponentParams = {};
        switch (type) {
            case MetaTagType.DOCKET_SELECTOR:
                this.extendedSearchComponent = DocketSelectorSearchPageComponent;
                this.extendedEditComponent = DocketSelectorEditPageComponent;
                break;
            case MetaTagType.ORDER_READY_QUALIFIER:
                this.extendedSearchComponent = OrderReadyQualifierSearchPageComponent;
                this.extendedEditComponent = OrderReadyQualifierEditPageComponent;
                break;
            case MetaTagType.PREPARATION:
            case MetaTagType.PREPARED_MESSAGE:
                this.extendedSearchComponent = PreparationModifierSearchPageComponent;
                this.extendedEditComponent = PreparationModifierEditPageComponent;
                this.extendedSearchComponentParams = {"type": type};
                this.extendedEditComponentParams = {"type": type};
                break;
        }
    }

    override onDataLoaded(data: Array<any>) {
        if (this.includeMatchNoTags) {
            data.unshift({
                [this.labelField]: this.translateService.instant(this.matchNoTagsLabel),
                [this.valueField]: MetaTagDefinitionData.MATCH_UNTAGGED_ITEM
            });
        }
    }

    override onOptionOpen(option: any) {
        if (option[this.valueField] !== MetaTagDefinitionData.MATCH_UNTAGGED_ITEM) {
            this.selectControlComponent.openView(option);
        }
    }
}
